import { Form, Input, Radio } from "antd";
import React, { useContext } from "react";
import icon1 from "../../../../../icons/call.png";
import telegram from "../../../../../icons/Telegram.png";
import whatsApp from "../../../../../icons/WhatsApp.png";
import email from "../../../../../icons/Gmail.png";
import instagram from "../../../../../icons/Instagram.png";
import linkDin from "../../../../../icons/Linkedin.png";
import icon2 from "../../../../../icons/Logo call.png";
import tak from "../../../../../icons/tak.png";
import ExpertDataContext from "../../../../../context/expertDataContext";

function ContactModal({ conections }) {
  const { expertDataAction } = useContext(ExpertDataContext);

  const handleChange = (e) => {
    expertDataAction(e?.target?.name, e?.target?.value);
  };

  return (
    <Form layout="vertical" className="flex flex-row    ">
      <section className="flex justify-start items-end flex-wrap gap-x-5 max-lg:items-start   max-lg:flex-col">
        <Form.Item
          className="hidden max-lg:block"
          labelWrap={false}
          label="آیا شماره تماس شما در سایت قابل مشاهده باشد؟"
        >
          <Radio.Group
            name="phoneNumberIsPublic"
            style={{ fontFamily: "IRANSansX" }}
            onChange={handleChange}
            defaultValue={conections?.showPhoneNumber}
          >
            <Radio value={true}>بله</Radio>
            <Radio value={false}>خیر</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="شماره تماس کاری:">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={icon2} />
            <Input
              defaultValue={conections?.phoneNumber}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              onChange={handleChange}
              placeholder="مثال:09155599612"
              name="phoneNumber"
            />
          </div>
        </Form.Item>
        <Form.Item
          className="max-lg:hidden"
          labelWrap={false}
          label="آیا شماره تماس شما در سایت قابل مشاهده باشد؟"
        >
          <Radio.Group
            style={{ fontFamily: "IRANSansX" }}
            onChange={handleChange}
            defaultValue={conections?.showPhoneNumber}
            name="phoneNumberIsPublic"
          >
            <Radio value={true}>بله</Radio>
            <Radio name="showPhoneNumber" value={false}>
              خیر
            </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="تلفن ثابت:">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={icon1} />
            <Input
              placeholder="مثال:05191004601"
              defaultValue={conections?.landingNumber}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="landingNumber"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="شماره واتساپ (کاری):">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={whatsApp} />
            <Input
              placeholder="مثال:09155599612"
              defaultValue={conections?.whatsApp}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="whatsappPhoneNumber"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="آی دی تلگرام (کاری):">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={telegram} />
            <Input
              placeholder="مثال:agro_expert"
              defaultValue={conections?.telegramId}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="telegramId"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="نشانی پست الکترونیکی:">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={email} />
            <Input
              placeholder="مثال:agroyar.ict@gamil.com"
              defaultValue={conections?.email}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="email"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="آی دی تاک:">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={tak} />
            <Input
              placeholder="مثال:agro_expert"
              defaultValue={conections?.takId}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="takId"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="آی دی اینستاگرام (کاری):">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={instagram} />
            <Input
              placeholder="مثال:agroyaar"
              defaultValue={conections?.instagram}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="instagramId"
              onChange={handleChange}
            />
          </div>
        </Form.Item>

        <Form.Item label="لینک لینکدین:">
          <div className="flex flex-row gap-1 ">
            <img className="w-8" alt="call" src={linkDin} />
            <Input
              placeholder="مثال:https://www.linkedin.com/in/mojtaba-hosseinian-4a50b0150/"
              defaultValue={conections?.linkDin}
              className="w-[17vw] max-lg:w-[75vw]"
              inputMode="tel"
              name="linkedInURL"
              onChange={handleChange}
            />
          </div>
        </Form.Item>
      </section>
    </Form>
  );
}

export default ContactModal;
